module.exports = __webpack_public_path__ + "img/69.da133072.jpg";